import React from 'react';
import {Button, Toast} from 'antd-mobile';
import Near from './Location/Near';

class SignIn extends React.Component{
    constructor(props){
        super(props);

        // let hasDisabledValue = signInData && Object.keys(signInData).includes('disabled');
        // this.state = {
        //     label: signInData ? signInData.label : '立即签到',
        //     is_enable_sign_out: data.is_enable_sign_out,
        //     sign_in_time: data.sign_in_time || null,
        //     sign_out_time: data.sign_out_time || null,
        //     sign_in_location: data.sign_in_location || '',
        //     sign_out_location: data.sign_out_location || '',
        //     is_sign_in: signInData && Object.keys(signInData).includes('is_sign_in') ? false : true,
        //     icon: data.icon || '',
        //     disabled: hasDisabledValue ? signInData.disabled : false
        // };

        this.state = {
            label: props.sign_in_button_name || '立即签到',
            is_enable_sign_out: true,
            sign_in_time: null,
            sign_out_time: null,
            sign_in_location: '',
            sign_out_location: '',
            icon: '',
            is_sign_in: true,   // 要签到
            disabled: false
        }
    }
    componentDidMount(){
        let AMap = window.AMap;
        if (AMap){
            this.execMap();
            return;
        }

        let interval = setInterval(()=>{
            let AMap = window.AMap;
            if (AMap){
                clearInterval(interval);
                this.execMap();
            }
        }, 300);
    }
  execMap = () => {
        let me = this;
        let AMap = window.AMap;
        AMap && AMap.service && AMap.service('AMap.Geocoder',()=> {
          let geocoder = new AMap.Geocoder({
              city: "010"//城市，默认：“全国”
          });

          // 获取高精度位置坐标
          var map = new AMap.Map('container')
          map.plugin('AMap.Geolocation', function () {
            var geolocation = new AMap.Geolocation({
              // 是否使用高精度定位，默认：true
              enableHighAccuracy: true,
              // 设置定位超时时间，默认：无穷大
              timeout: 10000,
            })

            geolocation.getCurrentPosition()
            AMap.event.addListener(geolocation, 'complete', (data) => {
              let { lng, lat } = data.position;
              geocoder.getAddress([lng, lat], (status, result) => {
                if (status === 'complete' && result.info === 'OK') {
                  me.setState({
                    sign_in_location: [lng, lat, result.regeocode.formattedAddress].join('#%$')
                  })
                }
              });
            })
          })
        })
    }
    clickHandle = (e)=>{
        e.preventDefault();

        let {is_enable_sign_out, is_sign_in} = this.state;

        if (!this.refs.signin.querySelector('.title')) {
            Toast.info($st('paas.select.location'), 1.5);
            return;
        };

        if (is_enable_sign_out) {
            if (is_sign_in) {
                this.setState({
                    sign_in_time: new Date().getTime(),
                    label: $st('签到成功'),
                    is_sign_in: false,
                    icon: 'check',
                    disabled: true
                });
                // Toast.info('签到成功', 1.5);
            }else {
                // this.setState({
                //     sign_out_time: new Date().getTime(),
                //     label: '已签退',
                //     icon: 'check',
                //     is_sign_in: false,
                //     disabled: true
                // });
                // Toast.info('签退成功', 1.5);
            }
        }else {
            // if (is_sign_in) {
            //     this.setState({
            //         sign_in_time: new Date().getTime(),
            //         label: '已签到',
            //         icon: 'check',
            //         is_sign_in: false,
            //         disabled: true
            //     });
            //     Toast.info('签到成功', 1.5);
            // }
        }

        e.stopPropagation();
    }
    onChange = (value)=>{
        let location = this.state.sign_in_time ? 'sign_out_location' : 'sign_in_location';
        this.setState({
            [location]: value
        });
        let onChange = this.props.onChange;
        onChange && onChange(value);
    }
    render(){
        let {api_name, form, fields} = this.props;
        let {sign_in_time_field, sign_out_time_field, sign_in_location_field, sign_out_location_field} = fields;
        let {icon, disabled, label, sign_in_time, sign_out_time, sign_in_location, sign_out_location, is_sign_in} = this.state;
        const { getFieldProps }  = form;
        let tempProps = {
            name: api_name,
            type: 'ghost',
            onClick: this.clickHandle,
            className: 'form-sign-in',
            icon: icon,
            disabled: disabled
        }
        let signInTimeFieldProps = getFieldProps(sign_in_time_field, {
            initialValue: sign_in_time
        });
        let signOutTimeFieldProps = getFieldProps(sign_out_time_field, {
            initialValue: sign_out_time
        });
        let signInLocationFieldProps = getFieldProps(sign_in_location_field, {
            initialValue: sign_in_location,
            validate: [{
                trigger: 'onChange'
            }]
        });
        let signOutLocationFieldProps = getFieldProps(sign_out_location_field, {
            initialValue: sign_out_location,
            validate: [{
                trigger: 'onChange'
            }]
        });

        return (
            <div ref='signin'>
                <Button {...tempProps} {...signInTimeFieldProps} {...signOutTimeFieldProps} {...signInLocationFieldProps} {...signOutLocationFieldProps}>{label}</Button>
                {sign_in_time && sign_out_time ? null : <Near isSignIn={true} is_sign_in={is_sign_in} {...signOutLocationFieldProps} {...signInLocationFieldProps} onChange={this.onChange.bind(this)}/>}
            </div>
        )
    }
}

export default SignIn;



// WEBPACK FOOTER //
// ./src/component/SignIn.js